export default __webpack_public_path__ + "static/media/white-bin.7eea749d.svg";